// ══════════════════════════════════════════════════════════════════
//  Sentry — observabilidade de erros em produção.
//  Tudo gated em REACT_APP_SENTRY_DSN: sem a var, é no-op (dev/local não
//  envia nada). Habilite setando a DSN no .env de produção.
// ══════════════════════════════════════════════════════════════════
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry(): void {
  if (!DSN) return; // sem DSN → não inicializa (local/dev)
  Sentry.init({
    dsn: DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE || undefined,
    // Só coleta em produção — evita ruído do dev server.
    enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0.1,
  });
}

// Reporta um erro capturado (ex.: pelo ErrorBoundary). No-op sem DSN.
export function reportError(error: Error, context?: Record<string, unknown>): void {
  if (!DSN) return;
  Sentry.captureException(error, context ? { extra: context } : undefined);
}
